// @ts-check

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Drawer from '@material-ui/core/Drawer';
import FormBuildingInfo from './FormBuildingInfo/index';
import FormCosts from './FormCosts/index';
import FormSustainability from './FormSustainability/index';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import SiteTabsContainer from '../SideTabsContainer/SideTabsContainer';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import clsx from 'clsx';
import HelpTab from './MoreInformation/Help';
import ContactUsTab from './MoreInformation/ContactUs';
import {
  SET_FORM_OPEN
} from '../../redux/actions/actionTypes'
import { Tooltip } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  formContainer: {
    display: "inline-block",
    position: "relative",
    flexGrow: 1,
    borderRight: `2px solid ${theme.palette.grey["A100"]}`,
    [theme.breakpoints.down("sm")]: {
      flexGrow: 1
    },
    [theme.breakpoints.down("md")]: {
      width: "50%"
    },
    left: 0,
    transition: "all 250ms ease-in-out",
  },
  fromContainerClose: {
    left: "-37.5%"
  },
  // Tab panel form
  tabPanelForm: {
    opacity: 1,
    height: "100vh",
    overflow: "auto",
    visibility: "hidden",
    transition: "all 250ms ease-in-out",
    '&:hover': {
      visibility: "visible"
    },
    '&:focus': {
      visibility: "visible"
    },
    // Scroll bar style
    '&::-webkit-scrollbar': {
      width: "8px",
      height: "8px"
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: "#fff"
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: "#D3D3D3",
      borderRadius: 4
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: "#B6B6B6"
    }
  },
  tabPanelFormClose: {
    opacity: 0
  },
  collapseBtn: {
    color: "#f50057",
    cursor: "pointer",
    visibility: "visible",
    position: "absolute",
    top: "0px",
    right: "0px"
  },
  openButton: {
    transform: "rotate(180deg)"
  },
  formWrapper: {
    display: 'flex',
    width: "600px"
  }
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box display={value === index ? "block" : "none"} {...other}>
      {children}
    </Box>
  )
}

function FormContainer() {
  const styles = useStyles();
  const dispatch = useDispatch()
  const topLevelState = useSelector(state => state.topLevel);

  return (
    <div>
      <React.Fragment key={'formDrawer'}>
        <Drawer anchor={'left'} open={topLevelState.form_open}>

          <div className={styles.formWrapper}>
            <SiteTabsContainer />

            <Box
              className={clsx(styles.formContainer, { [styles.fromContainerClose]: !topLevelState.form_open })}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <form
                className={clsx(styles.tabPanelForm, { [styles.tabPanelFormClose]: !topLevelState.form_open })}
                name="app-form"
                autoComplete="off">

                <Tooltip title="Collapse form">
                  <IconButton color="inherit"
                    className={styles.collapseBtn}
                    onClick={
                      (event) => {
                        dispatch({
                          type: SET_FORM_OPEN,
                          payload: false
                        })
                      }
                    }
                  >
                    <ArrowBackIosIcon />
                  </IconButton>
                </Tooltip>

                {/* Scroll content */}
                <div style={{ visibility: "visible" }}>
                  {/* Building info */}
                  <TabPanel value={topLevelState.active_tab} index={0}>
                    <FormBuildingInfo />
                  </TabPanel>

                  {/* Costs */}
                  <TabPanel value={topLevelState.active_tab} index={1}>
                    <FormCosts />
                  </TabPanel>

                  {/* Sustainability */}
                  <TabPanel value={topLevelState.active_tab} index={2}>
                    <FormSustainability />
                  </TabPanel>

                  {/* Help tab */}
                  <TabPanel value={topLevelState.active_tab} index={3}>
                    <HelpTab />
                  </TabPanel>

                  {/* Contact us tab */}
                  <TabPanel value={topLevelState.active_tab} index={4}>
                    <ContactUsTab />
                  </TabPanel>
                </div>
              </form>
            </Box>

          </div>
        </Drawer>

      </React.Fragment>

    </div>


  )
}

export default FormContainer;
